import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import style from "./style.vue";
export const videoImg = "https://ssl-picture.tenyun.runsasoft.com/shipinbofang.png";

@Component({
	components: {},
	mixins: [style],
})
export default class Video extends Vue {
	@Prop({ default: () => {} })
	value: DisplayVideoData;

	render(h) {
		return (
			<div class="video">
				<img src={videoImg} class="videoImg" />
			</div>
		);
	}
}
